export type RegistrationType =
    | "individual"
    | "group";

// Dostępne rozmiary koszulki i jersey — jedna wspólna lista dla obu pól.
export const APPAREL_SIZES = ["XS", "S", "M", "L", "XL", "XXL", "XXXL"] as const;
export type ApparelSize = typeof APPAREL_SIZES[number];
export const REZYGNUJE = 'REZYGNUJE' as const;


export interface RegistrationFormData {
    name: string;
    email: string;
    contact: string;
    registrationType: RegistrationType;
    groupSize: number;
    selectedEvents: string[];
    selectedOptions: number[];  // lista ID wybranych opcji
    comment: string;
    nickname: string;
    motorcycleBrand: string;
    shirtSize: string;
    jerseySize: string;
}
